export default "__VITE_ASSET__DFmHSK_u__"